import { useRef, useEffect } from "react";
import { LoginEmail } from "./loginEmail";
import { LoginVerify } from "./loginVerify";
import XbuttonIcon from "../../assets/xButtonIcon.svg";
import ZownIcon from "../../assets/zown-logo-blue-wide.svg";
import useLoginStepStore from "../../stores/loginStepStore";
import { useShowLoginModalStore } from "../../stores/loginModalStore";

const LoginModal = () => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const { setShowLoginModal } = useShowLoginModalStore();
  const { step } = useLoginStepStore();

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setShowLoginModal(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [setShowLoginModal]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-2">
      <div className="absolute inset-0 bg-white bg-opacity-70 backdrop-blur-sm" />
      <div
        ref={modalRef}
        className="relative w-full max-w-md py-6 px-6 bg-white shadow-md rounded-[20px] space-y-4 z-10 min-h-[480px] flex flex-col items-center justify-center"
      >
        <button
          type="button"
          className="right-4 absolute w-[46px] h-[46px] rounded-full flex items-start justify-end top-4"
          onClick={() => setShowLoginModal(false)}
        >
          <img src={XbuttonIcon} alt="Close" />
        </button>
        <div className="flex justify-center w-full">
          <img src={ZownIcon} alt="Zown Logo" className="w-[201px]" />
        </div>
        <div className="w-full">
          {step === 1 ? <LoginEmail /> : step === 2 ? <LoginVerify /> : null}
        </div>
      </div>
    </div>
  );
};

export { LoginModal };
